import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { AreaDistributionItem } from '../../../../services/collects-analytics/collects-analytics.model';
import { GetAdminOrganisationAreas } from '../../../../global.model';

@Component({
    selector: 'app-collects-area-users-chart',
    templateUrl: './collects-area-users-chart.component.html',
    styleUrls: ['./collects-area-users-chart.component.scss'],
})
export class CollectsAreaUsersChartComponent implements OnChanges {
    @Input() data: AreaDistributionItem[] = [];
    @Input() areas: GetAdminOrganisationAreas[] = [];

    chartData: ChartConfiguration<'doughnut'>['data'] = { labels: [], datasets: [] };
    chartOptions: ChartConfiguration<'doughnut'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: { boxWidth: 12, padding: 12, font: { family: "'Montserrat', sans-serif", size: 12 } },
            },
        },
        cutout: '60%',
    };

    private fallbackPalette = ['#3a7bd5', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#f97316', '#14b8a6', '#6366f1'];

    constructor(private translate: TranslateService) {}

    private resolveAreaName(area: GetAdminOrganisationAreas): string {
        const name = area.name as any;
        if (typeof name === 'string') return name;
        return name[this.translate.currentLang] || name['fr'] || name['en'] || String(name);
    }

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;

        const areaMap = new Map(this.areas.map((a) => [a._id, this.resolveAreaName(a)]));

        this.chartData = {
            labels: this.data.map((d) => areaMap.get(d.label) || d.label),
            datasets: [
                {
                    data: this.data.map((d) => d.userCount),
                    backgroundColor: this.data.map((_, i) => this.fallbackPalette[i % this.fallbackPalette.length]),
                    borderWidth: 2,
                    borderColor: '#ffffff',
                },
            ],
        };
    }
}
